import {AnswerTemplateAggregate} from "../../../../domain";
import {AnswerTemplateDto} from "../dtos";

export const answerTemplateAggregateToDto = (aggregate: AnswerTemplateAggregate): AnswerTemplateDto => ({
  idAnswerTemplate: aggregate.idAnswerTemplate,
  title: aggregate.title,
  content: aggregate.content,
  companiesIds: aggregate.companiesIds,
  selected: false
});

export const answerTemplateDtoToAggregate = (dto: AnswerTemplateDto): AnswerTemplateAggregate =>
  AnswerTemplateAggregate.getInstance({
    idAnswerTemplate: dto.idAnswerTemplate,
    title: dto.title,
    content: dto.content,
    companiesIds: dto.companiesIds,
  });
